import axios from "axios";

function initAxios(router) {
    axios.defaults.baseURL = import.meta.env.VITE_API_URL;
    axios.defaults.withCredentials = true;
    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.defaults.withXSRFToken = true;

    const bearerToken = localStorage.getItem('bearerToken');
    axios.defaults.headers = { Authorization: `Bearer ${bearerToken}` };
}

export { initAxios };
